import React from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';

class Page2 extends React.PureComponent {
  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }
  }

  render() {
    return (
      <div className="page-2 legal-page" ref={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <div className="justifycentre register-block legal-header">
          <Heading tag="h1" classes="header-text smaller"><span id="register2">Privacy</span></Heading>
          <Paragraph classes="larger">Do you agree to share your information with LiveWell Dorset (part of Public Health Dorset)?</Paragraph>
        </div>
        <div className="legal-content-wrap">
          <Paragraph>We’re going to ask you some questions about you and your health and lifestyle, which we’ll use to inform the support we offer you. Your data is stored securely and only available to people who need access to it (those who deliver the service and who help us to safely and securely store our data).</Paragraph>
          <Paragraph>Depending on the type of support you choose, we may introduce you with services such as slimming clubs and pharmacies. To do this, we’ll need to share some information about you with them. If we link you with other services, we’ll <span>always</span> ask you whether you agree for us to share information with them.</Paragraph>
          <Paragraph>We’ll ask you information including your ethnicity and any disabilities you may have. This is firstly to ensure that we’re and inclusive service; accessible to meet a whole range of people. Secondly, we want to be aware of anything we need to take into consideration when directing you to partner services and activities. If you’d prefer to not share this information, that’s fine - the choice is yours.</Paragraph>
          <Paragraph><span>Before we can sign you up, we need to know that:</span></Paragraph>
          <ul>
            <li>{"You're"} happy for your personal information to be stored by LiveWell Dorset.</li>
            <li>You understand that we work with partner companies to help manage our data (these partners have the same standards as we do to protect your data)</li>
            <li>You understand what information may be shared and why</li>
            <li>You understand that you can withdraw your consent at any time by letting us know</li>
            <li>You understand that if you do not consent (or if you later withdraw your consent), it can be difficult for us to offer you some of the services we provide</li>
          </ul>
          <Heading tag="h3" classes="header-text">Prefer to talk on the phone?</Heading>
          <Paragraph>If you need more information before going ahead, please phone us on freephone <span>0800 840 1628</span>. We’re open weekdays, 9am – 6:30pm. Our team of local advisors can explain more and answer any questions you may have. You can complete the registration over the phone if you would prefer. You can also <a href="/contact/" target="_blank">send us a message</a>.</Paragraph>
          <Paragraph classes="flex-row button-groups">
            <Button classes={['color-button']} label="Yes, I consent" onClick={this.props.onSubmit} />
          </Paragraph>
        </div>
      </div>
    );
  }
}

Page2.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onNoConsent: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'registration', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Page2);



// WEBPACK FOOTER //
// ./src/Components/Register/FormPages/Page2.jsx